export default __webpack_public_path__ + "static/media/merz-selfie-booth.3943585c.png";